import { render } from "./KonvaVideo.vue?vue&type=template&id=0420344b"
import script from "./KonvaVideo.vue?vue&type=script&lang=js"
export * from "./KonvaVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__